import { SVGProps } from '@components/Icon/types';

export const DeliveryAddress = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4.5, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70064 3.60125L7.89418 3.61539C9.86272 3.81316 11.3885 5.45885 11.3885 7.47205L11.3832 7.67178C11.2826 9.65714 9.69585 11.2388 7.70242 11.342L7.50178 11.3473H7.49822C5.41165 11.3437 3.71986 9.72324 3.61594 7.67178L3.61151 7.47205C3.61151 5.32699 5.34391 3.59967 7.49822 3.59595H7.50266L7.70064 3.60125ZM7.5 4.77221C5.99764 4.77481 4.79315 5.97587 4.79315 7.47205L4.7967 7.61168C4.8692 9.0419 6.04487 10.1685 7.5 10.171L7.63938 10.1675C9.07593 10.0936 10.2065 8.92135 10.2069 7.47205L10.2033 7.33242C10.1335 5.94783 9.02969 4.84734 7.63938 4.77575L7.5 4.77221Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8853 0.0106049C11.6628 0.204851 14.672 3.20509 14.9787 7.06376L15 7.45173L14.9991 7.8229C14.9397 9.69499 14.0542 11.8235 12.9093 13.8164C11.84 15.6776 10.5412 17.4268 9.46733 18.7486L9.02166 19.2886C8.68546 19.6899 8.21755 19.9308 7.72017 19.9867L7.5071 19.9982C7.50648 19.9984 7.50487 19.9989 7.50355 19.9991L7.49467 20C6.99056 19.9974 6.50101 19.8057 6.12926 19.4503L5.97745 19.2886C4.83408 17.9247 3.312 15.9437 2.08984 13.8164C0.944883 11.8235 0.0594023 9.69499 0 7.8229V7.45173L0.0213068 7.06376C0.33819 3.07651 3.54057 0.00523026 7.49467 0H7.50533L7.8853 0.0106049ZM7.17685 1.18422L7.17773 1.1851C3.91271 1.35305 1.29106 4.02783 1.18075 7.48884C1.13478 9.10873 1.91882 11.1498 3.11523 13.2323L3.33896 13.6141C4.47103 15.5115 5.82996 17.2763 6.87855 18.5277L6.88388 18.533L6.94691 18.601L7.0055 18.6523C7.14646 18.7632 7.31952 18.8217 7.49911 18.8229L7.58612 18.8176C7.78891 18.7951 7.977 18.6976 8.11346 18.5348L8.12766 18.5188L8.54936 18.0072L8.95153 17.5043C9.9086 16.291 10.9844 14.7977 11.8839 13.2323L12.104 12.8417C13.1755 10.8962 13.8621 9.00809 13.8192 7.48973L13.8006 7.15655L13.7695 6.8499C13.3789 3.70326 10.8828 1.34241 7.82138 1.1851L7.50266 1.17715H7.49734L7.17685 1.18422Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'delivery-address';
